import { useMemo } from 'react';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { usePartner } from 'components/app/routes/usePartner';
import { BritishGasBenefits } from 'components/direct-sales/quote/components/BritishGasBenefits';
import { DirectDebitPromotionExpander } from 'components/direct-sales/quote/components/DirectDebitPromotionExpander';
import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';
import { MoreInformation } from 'components/direct-sales/quote/components/MoreInformation';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';
import { NsAccordion } from 'components/common/ns-accordion/NsAccordion';

export const quoteCaveatTestId = 'quoteCaveatTestId';

export const QuoteFooter = () => {
  const { isDSJourney } = usePartner();
  const isAgentJourney = useIsLoginEnabledJourney();

  const hasAccordion = !isAgentJourney || isDSJourney;

  return useMemo(
    () => (
      <>
        <NsPanel decoration="cyan-light">
          {hasAccordion && (
            <NsAccordion>
              <MoreInformation />
              <DirectDebitPromotionExpander shouldShow={isDSJourney} />
            </NsAccordion>
          )}
        </NsPanel>
        <BritishGasBenefits />
        <NsCaveat testId={quoteCaveatTestId} heading="Legal information" />
      </>
    ),
    [isDSJourney, hasAccordion]
  );
};

export default QuoteFooter;
